import { Grid, Box } from '@mui/material';

import Form from 'components/Form';
import { IFormRegister, IFormValues } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormRegister, IFormValues {
  disabled?: boolean;
}

const checks = [
  {
    label: '患者的權利與責任',
    key: 'education_list.checked1',
  },
  {
    label: '入院需攜帶的物品',
    key: 'education_list.checked2',
  },
  {
    label:
      '您房間內的設施（床、床頭櫃、床燈、電話、電視、緊急呼叫鈴、護理呼叫鈴、空調、暖氣等）',
    key: 'education_list.checked3',
  },
  {
    label: '護理單元的設施',
    key: 'education_list.checked4',
  },
  {
    label: '醫院的設施',
    key: 'education_list.checked5',
  },
  {
    label: '使用床頭電話和訪問互聯網',
    key: 'education_list.checked6',
  },
  {
    label: '呼叫護理需求協助',
    key: 'education_list.checked7',
  },
  {
    label: '火災與煙霧預防及火災時應採取的措施',
    key: 'education_list.checked8',
  },
  {
    label: '防盜措施',
    key: 'education_list.checked9',
  },
  {
    label: '受傷/跌倒預防',
    key: 'education_list.checked10',
  },
  {
    label: '客人探訪時間和用餐時間',
    key: 'education_list.checked11',
  },
  {
    label: '選擇專家的權利及支付專家諮詢費用的責任',
    key: 'education_list.checked12',
  },
  {
    label: '醫生查房時間',
    key: 'education_list.checked13',
  },
  {
    label: '請求必要文件（醫療證明、出勤記錄）',
    key: 'education_list.checked14',
  },
  {
    label: '表揚與投訴的報告系統',
    key: 'education_list.checked15',
  },
  {
    label: '請求護理人員',
    key: 'education_list.checked16',
  },
  {
    label: '住院期間外出',
    key: 'education_list.checked17',
  },
  {
    label: '客服服務',
    key: 'education_list.checked18',
  },
  {
    label: '停車',
    key: 'education_list.checked19',
  },
  {
    label: '住院期間的中期付款',
    key: 'education_list.checked20',
  },
  {
    label: '出院程序',
    key: 'education_list.checked21',
  },
];

const EducationList = (props: Props) => {
  const { disabled, register, getValues, setValue } = props;

  return (
    <>
      <SectionTitle title="如果您/您的家屬已從醫院工作人員處獲得信息或指導並完全理解，請勾選以下項目。" />
      <Box sx={{ width: '98%', margin: '48px auto 24px auto' }}>
        <Grid container xs={12}>
          {checks.map((v, i) => (
            <Grid item xs={12}>
              <Form.MuiCheckbox
                label={v.label}
                disabled={disabled}
                defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                onChange={(_, checked) => {
                  setValue(v.key, checked);
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default EducationList;
